(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  'use strict';
  /* the basket drawer's own buttons: open and close, and a line's −, + and Remove. A change goes through Shopify's
     cart (Ounce.cartChange sends shopify:cart:lines-update) and asks for this section back, which redraws the drawer. */
  const O = window.Ounce, drawer = document.querySelector('dialog.drawer');
  if (O && drawer) {
    document.querySelectorAll('[data-open-bag]').forEach(b => b.addEventListener('click', e => O.bag.open(b, O.pointer(e))));
    drawer.addEventListener('click', e => {
      if (e.target.closest('[data-close-bag]')) { O.bag.close(O.pointer(e)); return; }
      const b = e.target.closest('button[data-set]'); if (!b) return;
      const to = +b.dataset.to;
      b.disabled = true;
      O.cartChange(drawer, to ? 'update' : 'remove', 'cart', [{ id: b.dataset.key, quantity: to }],
        () => O.api('cart/change.js', { line: +b.dataset.set, quantity: to, sections: O.BAG, sections_url: location.pathname }))
        .then(c => { O.drawBag(c.sections); O.setCart(c); })
        .catch(err => { b.disabled = false; O.toast(O.esc(err.message)); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  'use strict';
  /* The basket page's − , + and Remove through the AJAX cart; the page and the drawer redraw from what Shopify
     renders with the change. A change elsewhere (the drawer) redraws the page when the cart no longer matches it. */
  (() => {
    const O = window.Ounce, root = document.querySelector('[data-cart-page]');
    if (!O || !root) return;
    const id = root.dataset.section;
    const draw = (html, focus) => {
      if (!html) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-rows]');
      const rows = root.querySelector('[data-cart-rows]');
      if (!next || !rows) return;
      rows.replaceWith(next);
      if (focus) (next.querySelector(focus) || next.querySelector('h1'))?.focus({ preventScroll: true });
    };
    root.addEventListener('click', e => {
      const a = e.target.closest('a[data-set]'); if (!a) return;
      e.preventDefault();
      if (a.getAttribute('aria-disabled') === 'true') return;
      const to = +a.dataset.to, key = a.dataset.key, act = a.dataset.act;
      root.querySelectorAll('a[data-set]').forEach(b => b.setAttribute('aria-disabled', 'true'));
      O.cartChange(root, to ? 'update' : 'remove', 'cart', [{ id: key, quantity: to }],
        () => O.api('cart/change.js', { line: +a.dataset.set, quantity: to, sections: [O.BAG, id], sections_url: location.pathname }))
        .then(c => {
          O.drawBag(c.sections);
          draw(c.sections && c.sections[id], `a[data-key="${CSS.escape(key)}"][data-act="${act}"]`);
          O.setCart(c);
        })
        .catch(err => {
          root.querySelectorAll('a[data-set]').forEach(b => b.removeAttribute('aria-disabled'));
          O.toast(O.esc(err.message));
        });
    });
    document.addEventListener('ounce:cart', e => {
      const c = e.detail, rows = root.querySelector('[data-cart-rows]');
      if (!c || !rows || rows.dataset.sig === `${c.item_count}-${c.total_price}`) return;
      // no Accept: application/json here — /cart would answer with the cart itself instead of the section
      fetch(`${location.pathname}?sections=${encodeURIComponent(id)}`)
        .then(r => r.json()).then(j => draw(j[id])).catch(() => { });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  'use strict';
  /* phones: the "1 / 5" in the gallery's corner follows the sideways scroll */
  const gal = document.querySelector('.pdp [data-gallery]'), gc = document.querySelector('.pdp [data-gcount]');
  if (gal && gc) {
    const n = gal.children.length;
    gal.addEventListener('scroll', () => {
      const i = Math.round(gal.scrollLeft / (gal.scrollWidth / n)) + 1;
      gc.textContent = `${Math.min(n, Math.max(1, i))} / ${n}`;
    }, { passive: true });
  }

  } catch(e) { console.error(e); }
})();
})();
